import { createContext, useContext, useState, type ReactNode } from 'react';
import type { AuthContextType, User } from '../types/ContextTypes';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(() => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return null;
    try {
      return JSON.parse(storedUser) as User;
    } catch {
      localStorage.removeItem('user');
      return null;
    }
  });

  const login = (email: string, password: string): Promise<boolean> => {
    if (password.length >= 6) {
      const mockUser: User = { id: '1', name: email.split('@')[0], email };
      setUser(mockUser);
      localStorage.setItem('user', JSON.stringify(mockUser));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  };

  const signup = (
    name: string,
    email: string,
    password: string
  ): Promise<boolean> => {
    if (name && email && password.length >= 6) {
      const mockUser: User = { id: Date.now().toString(), name, email };
      setUser(mockUser);
      localStorage.setItem('user', JSON.stringify(mockUser));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        signup,
        logout,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
